import { useCallback, removeItemAtIndex } from "@";

// Hook for removing an item from a list
export const useRemoveItem = (getValues, setValue) => {
  const removeItem = useCallback(
    (field, index) => {
      let fieldArray = getValues(field);

      const updatedArray = removeItemAtIndex(fieldArray, index);

      setValue(field, updatedArray);
    },
    [getValues, setValue],
  );

  return { removeItem };
};
